import React from "react";
import earth from "../../../asset/Uranus.png";
import styleSheet from "./style.module.scss";
import sunpin from "../../../asset/sunpin.png";
import earthpin from "../../../asset/earthpin.png";
import marspin from "../../../asset/marspin.png";
import mercurypin from "../../../asset/mercurypin.png";
import jupiterpin from "../../../asset/jupiterpin.png";
import saturnpin from "../../../asset/saturnpin.png";
import uranuspin from "../../../asset/uranuspin.png";

type Props = {
  location?: string;
  businessName?: string;
};

const SyPin = ({ location, businessName }: Props) => {
  const defaultLocation = "chennai";
  const defaultBusinessName = "My Business Name";
  const width = "100%";
  const height = "600";
  const zoom = "1";
  const apiKey = "AIzaSyC5XJGsQBkenVFWZ2no93Nude9fNu_-bLc"; 
  const encodedLocation = encodeURIComponent(location || defaultLocation);
  const encodedBusinessName = encodeURIComponent(businessName || defaultBusinessName);
  const markerUrl = encodeURIComponent(sunpin);
  // const dynamicSrc = `https://maps.google.com/maps?width=${width}&amp;height=${height}&amp;hl=en&amp;q=${encodedLocation}+(${encodedBusinessName})&amp;t=&amp;z=${zoom}&amp;ie=UTF8&amp;iwloc=B&amp;output=embed&key=${apiKey}&amp;markers=${markerUrl}`;
  const dynamicSrc = `https://maps.google.com/maps?width=${width}&amp;height=${height}&amp;hl=en&amp;q=${encodedLocation}+(${encodedBusinessName})&amp;t=&amp;z=${zoom}&amp;ie=UTF8&amp;iwloc=B&amp;`;

  const url = dynamicSrc + "&output=embed&key=AIzaSyC5XJGsQBkenVFWZ2no93Nude9fNu_-bLc&amp;";
  

 
  return (
    <div className={`${styleSheet.map} col-5 mt-5  ms-5 `}>
      <iframe
        id="iframemap"
        src={url}
        // src='https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=india+(My%20Business%20Name)&amp;t=&amp;z=1&amp;ie=UTF8&amp;iwloc=B&amp;output=embed&key=AIzaSyC5XJGsQBkenVFWZ2no93Nude9fNu_-bLc&amp;markers=%2Fstatic%2Fmedia%2Fsunpin.a215c9e4c353d3c9a903.png&output=embed&key=AIzaSyC5XJGsQBkenVFWZ2no93Nude9fNu_-bLc&amp;'
        
        width="100%"
        height="100%"
      ></iframe>
    </div>
  );
};

export default SyPin;





